import { createContext, useState, useEffect, useContext } from "react";
import { ThemeProvider as MUIThemeProvider, CssBaseline } from "@mui/material";
import { lightTheme, darkTheme } from "../theme"; // Importáljuk a MUI témákat

// 1️⃣ Létrehozzuk a Context-et
const ThemeContext = createContext();

// 2️⃣ Létrehozunk egy ThemeProvider komponenst
export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);

  // 3️⃣ Mentett beállítás betöltése localStorage-ból
  useEffect(() => {
    const savedTheme = localStorage.getItem("darkMode");
    if (savedTheme) {
      setDarkMode(JSON.parse(savedTheme));
    }
  }, []);

  // 4️⃣ Témaváltás függvény
  const toggleTheme = () => {
    setDarkMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem("darkMode", JSON.stringify(newMode)); // Mentés localStorage-ba
      return newMode;
    });
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleTheme }}>
      <MUIThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

// 5️⃣ Saját hook, hogy könnyen használható legyen a Context
export const useTheme = () => useContext(ThemeContext);
